import React from 'react'
import {
  Hint,
  LocalizedText,
  Indicator,
  LocalizedDate,
  LocalizedNumber,
  LocalizedTime,
  ClockIcon,
  useFormValue,
} from 'labguard-cdk'
import { I18n, PercentageIcon, CalendarAltIcon } from 'src/components/common'

const LocaleExamples = () => {
  const langId = useFormValue('langId')
  const localeId = useFormValue('localeId')

  const date = React.useMemo(() => new Date(), [])
  return (
    <Hint label={<LocalizedText id="WEB_EXAMPLES" />} color="primary">
      <I18n {...{ langId, localeId }}>
        <Indicator
          icon={PercentageIcon}
          height="1.5rem"
          color="primary"
          separator
          title={<LocalizedNumber value={1423.55} />}
          subtitle={<LocalizedText id="WEB_NUMBER" />}
        />
        <Indicator
          icon={ClockIcon}
          height="1.5rem"
          color="primary"
          separator
          title={<LocalizedTime value={date} />}
          subtitle={<LocalizedText id="WEB_TIME" />}
        />
        <Indicator
          icon={CalendarAltIcon}
          height="1.5rem"
          color="primary"
          separator
          title={<LocalizedDate value={date} />}
          subtitle={<LocalizedText id="WEB_DATE" />}
        />
      </I18n>
    </Hint>
  )
}

export default LocaleExamples
